import React from "react";

const THUMBNAIL_COUNT = 12;

interface ProjectThumbnailProps {
  projectId: string;
  projectName: string;
  index?: number;
  className?: string;
}

/** Renders a stock thumbnail image for a project based on its index in the list. */
export const ProjectThumbnail: React.FC<ProjectThumbnailProps> = ({
  projectName,
  index = 0,
  className,
}) => {
  const imgNum = (index % THUMBNAIL_COUNT) + 1;
  return (
    <img
      src={`/thumbnails/img${imgNum}.png`}
      alt={`${projectName} architecture diagram`}
      className={`bg-white opacity-80 pointer-events-none ${className ?? ""}`}
      draggable={false}
    />
  );
};
